import { getAbout } from '../services/api.js';
import { element, showMessage, safePublicUrl } from '../components/publicUi.js';
import { FeedbackForm } from '../components/FeedbackForm.js';
import { authService } from '../services/authService.js';

export class AboutPage {
  constructor(_navigate, send = (...args) => authService.submitFeedback(...args)) { this.send = send; }
  render() {
    const page = element('div', 'page-wrapper'), container = element('div', 'container'), header = element('div', 'page-header');
    header.append(element('div', 'page-breadcrumb', '/var/www/fixlan.ru > about_manifesto'), element('h1', 'page-title', '>_ ./about.md'),
      element('p', 'page-desc', 'Манифест, профиль исследователя безопасности, инструменты и контакты.'));
    this.content = element('div'); container.append(header, this.content); page.appendChild(container);
    void this.load(); return page;
  }
  async load() {
    this.controller?.abort(); this.feedbackForm?.dispose(); this.controller = new AbortController(); const { signal } = this.controller;
    showMessage(this.content, 'Загрузка профиля…');
    try {
      const profile = await getAbout({ signal }); if (signal.aborted) return;
      const grid = element('div', 'about-grid'), left = element('div'), right = element('div');
      const box = (title) => { const node = element('section', 'spec-box glow-box'); node.appendChild(element('h2', 'spec-title', `> ${title}`)); return node; };
      const bio = box('Идентификация и манифест');
      bio.append(element('p', 'profile-text', profile.whoamiText), element('p', 'profile-text', profile.bio), element('p', 'profile-text', profile.missionText));
      const specializations = element('ul', 'profile-text');
      for (const text of profile.specializations) specializations.appendChild(element('li', '', text));
      bio.appendChild(specializations);
      const toolkit = box('Арсенал инструментов');
      for (const group of profile.toolGroups) {
        toolkit.appendChild(element('h3', 'profile-group', `// ${group.name}`)); const list = element('div', 'skills-list');
        for (const tool of group.tools) list.appendChild(element('span', 'skill-tag', tool));
        toolkit.appendChild(list);
      }
      left.append(bio, toolkit);
      const pgp = box('Публичный ключ PGP'); pgp.appendChild(element('p', 'profile-text', 'Публичный ключ не опубликован.'));
      const contacts = box('Контакты'); let links = 0;
      for (const link of profile.publicLinks) {
        const href = safePublicUrl(link.href); if (!href) continue;
        const a = element('a', 'profile-link', link.label); a.href = href; a.rel = 'noopener noreferrer'; contacts.appendChild(a); links++;
      }
      if (!links) contacts.appendChild(element('p', 'profile-text', 'Контактные ссылки пока не опубликованы.'));
      const form = box('./send_message.sh (Обратная связь)');
      form.appendChild(element('p', 'profile-text', 'Сообщение сохраняется во входящих администратора. Ответ на указанный контакт отправляется отдельно.'));
      this.feedbackForm = new FeedbackForm({ send: this.send }); form.appendChild(this.feedbackForm.render());
      right.append(pgp, contacts, form); grid.append(left, right); this.content.replaceChildren(grid);
    } catch (error) { if (!signal.aborted) showMessage(this.content, error.message, () => this.load()); }
  }
  dispose() { this.controller?.abort(); this.feedbackForm?.dispose(); }
}
